const hraInputs = {
	GADa: 'not answered',
	GADb: 'not answered',
	GADc: 'not answered',
	GADd: 'not answered',
	GADe: 'not answered',
	GADf: 'not answered',
	GADg: 'not answered',
	PHQa: 'not answered',
	PHQb: 'not answered',
	PHQc: 'not answered',
	PHQd: 'not answered',
	PHQe: 'not answered',
	PHQf: 'not answered',
	PHQg: 'not answered',
	PHQh: 'not answered',
	PHQi: 'not answered',
	age_in_years: 'not answered',
	arrested_dui: 'not answered',
	bathing: 'not answered',
	blood_glucose: 'not answered',
	blood_pressure_estimated: 'not answered',
	blood_pressure_measured_high_number: 'not answered',
	blood_pressure_measured_low_number: 'not answered',
	blood_pressure_medication: 'not answered',
	body_frame_size: 'not answered',
	butter: 'not answered',
	caffeine: 'not answered',
	chh_cough: 'not answered',
	chh_fever: 'not answered',
	chh_hands: 'not answered',
	chh_interact: 'not answered',
	chh_sbreath: 'not answered',
	cholesterol_check: 'not answered',
	cholesterol_level: 'not answered',
	cholesterol_level_estimated: 'not answered',
	cholesterol_medication: 'not answered',
	colon_cancer_screening: 'not answered',
	commercial_driver: 'not answered',
	daily_cigars: 'not answered',
	daily_marajuana: 'not answered',
	daily_pipes: 'not answered',
	daily_shisha: 'not answered',
	desserts: 'not answered',
	difficulties_piling_up: 'not answered',
	distracted_driving: 'not answered',
	dressing: 'not answered',
	drinking_and_driving: 'not answered',
	driving_speed: 'not answered',
	eating: 'not answered',
	fast_food: 'not answered',
	felt_confident: 'not answered',
	fruit: 'not answered',
	getting_outside: 'not answered',
	going_your_way: 'not answered',
	hdl_cholesterol: 'not answered',
	hdl_cholesterol_estimated: 'not answered',
	heavy_housework: 'not answered',
	height_cm: 'not answered',
	junk_food: 'not answered',
	light_housework: 'not answered',
	limit_crime: 'not answered',
	managing_money: 'nto answered',
	meals: 'not answered',
	out_of_bed: 'not answered',
	out_of_house: 'not answered',
	prostate_cancer_screening: 'not answered',
	protein: 'not answered',
	relatives_cancer: 'not answered',
	safety_belt_usage: 'not answered',
	sex: 'not answered',
	shopping: 'not answered',
	sleep1: 'not answered',
	sleep2: 'not answered',
	sleep3: 'not answered',
	sleep4: 'not answered',
	smokeless_tobacco: 'not answered',
	smoking: 'not answered',
	soft_drinks: 'not answered',
	still_smoke: 'not answered',
	street_drugs: 'not answered',
	sugar_beverage: 'not answered',
	telephone: 'not answered',
	triglycerides: 'not answered',
	// travel_by_automobile_km: '0',
	// travel_by_motorcycle_km: '0',
	typical_travel_method: 'not answered',
	unable_to_control: 'not answered',
	unprotected_sex: 'not answered',
	used_to_smoke_cigarettes_day: 'not answered',
	used_to_smoke_cigars_day: 'not answered',
	used_to_smoke_pipes_day: 'not answered',
	using_toilet: 'not answered',
	vaping: 'not answered',
	vaping_freq: 'not answered',
	vegetables: 'not answered',
	walking: 'not answered',
	weekly_alcohol_beer: 'not answered',
	weekly_alcohol_mixed_drinks: 'not answered',
	weekly_alcohol_wine: 'not answered',
	weekly_alcohol_wine_coolers: 'not answered',
	weight_kg: 'not answered',
	years_since_quitting_months: 'not answered',
	years_since_quitting_years: 'not answered',
};


export default hraInputs;